import { Link as RouterLink } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import { useTheme } from '@mui/material/styles';

import {
  dateColumn,
  errorsColumn,
  idColumn,
  stateColumn,
  taskCountColumn,
  tasksColumn,
  userColumn,
} from 'pages/WorkflowRunsPage/workflowListColumns';

import useAutofetchedAccountsAsync from 'store/useAutofetchedAccountsAsync';
import useDashboardUsersAsync from 'store/useDashboardUsersAsync';
import useProjectsAsync from 'store/useProjectsAsync';

import IRunEntry from 'types/IRunEntry';
import IColumnDefinition from '../WorkflowRunsPage/Table/IColumnDefinition';

export function useDashboardColumns(
  onShowErrors: (run: IRunEntry) => void,
  stateFilter?: { onStateClick?: (state: string) => void; selectedState?: string },
): IColumnDefinition<IRunEntry>[] {
  const theme = useTheme();
  const projectsAsync = useProjectsAsync();
  const projects =
    (projectsAsync.status === 'SUCCESS' || projectsAsync.status === 'REFRESH' ? projectsAsync.data : null) ?? [];
  const projectNamesById = new Map(projects.map((project) => [project.id, project.name]));

  const usersAsync = useDashboardUsersAsync();
  const users = (usersAsync.status === 'SUCCESS' || usersAsync.status === 'REFRESH' ? usersAsync.data : null) ?? [];
  const usersById = new Map(users.map((user) => [user.id, user]));

  const accountsAsync = useAutofetchedAccountsAsync();
  const accounts =
    (accountsAsync.status === 'SUCCESS' || accountsAsync.status === 'REFRESH' ? accountsAsync.data : null) ?? [];
  const accountsById = new Map(accounts.map((account) => [account.id, account]));

  return [
    {
      header: 'Name',
      key: 'name',
      render: (run) => (
        <MuiLink component={RouterLink} to={`/projects/${run.project_id}/workflows/${run.id}/details`}>
          {run.name}
        </MuiLink>
      ),
    },
    {
      header: 'Project',
      key: 'project_id',
      render: (run) => (
        <MuiLink component={RouterLink} to={`/projects/${run.project_id}/workflows`}>
          {projectNamesById.get(run.project_id) ?? run.project_id}
        </MuiLink>
      ),
    },
    dateColumn(),
    idColumn(),
    userColumn(usersById, accountsById),
    stateColumn(theme, stateFilter),
    tasksColumn(stateFilter),
    taskCountColumn(),
    errorsColumn(onShowErrors),
  ];
}
